import { useFeatureGate } from '@trello/feature-gate-client';

export const useIsInboxAutoArchiveEnabled: () => boolean = () => {
  const { value: isInboxAutoArchiveGateEnabled } = useFeatureGate(
    'phx_inbox_auto_archive_m1',
  );

  const { value: isInboxAutoArchiveOverrideEnabled } = useFeatureGate(
    'phx_inbox_auto_archive_override',
  );

  // TODO: check board pref from apollo
  const autoArchiveBoardPref = undefined;

  return (
    isInboxAutoArchiveOverrideEnabled ||
    (isInboxAutoArchiveGateEnabled && !!autoArchiveBoardPref)
  );
};
